<template>
    <div>
        <div class="panel-tag mt-2">
            {{__t("GLOVO_LOCATION_PARAMS")}}
        </div>


        <div class="">
            <label class="form-label" for="glovo_location">{{__t("GLOVO_LIST")}}</label>

            <v-select
                @input="get_locations"
                v-model="general_fields.ext_id"
                class="imc_reasons"
                :reduce="item => item.id"
                label="username"
                :options="this.auth_ext"
            >
                <template slot="option" slot-scope="option">
                    <div class="d-center">
                        <div>
                            {{option.username}} - {{ option.id }}
                        </div>
                    </div>
                </template>
            </v-select>

        </div>

        <div class="form-group form-group mt-4 pb-4">
            <b-overlay :show="is_load">
                <label class="form-label" for="glovo_location">
                    {{__t("GLOVO_REST")}}*
                </label>

                <div class="" v-if="ext_restaurants.length > 0">
                    <v-select
                            v-model="general_fields.store_id"
                              class="imc_reasons"
                              :reduce="item => item.id"
                              label="address"
                              :filter="searchRest"
                              :options="this.ext_restaurants"
                    >
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                <div>
                                    {{option.id}} - {{ option.address }}
                                </div>
                            </div>
                        </template>
                    </v-select>
                </div>
            </b-overlay>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';

export default {
    name: "glovo_review_params",
    props : {
        location : {
            type : Object
        }
    },

    data() {

        return {
            ext_restaurants : [],
            auth_ext : [],
            is_load : false,
            is_own_auth : false,
        }
    },

    components : {
        vSelect
    },

    mounted() {
        this.loadGlovoAuthList();
    },

    methods : {

        async loadGlovoAuthList() {
            this.auth_ext = [];
            await api.get('/internal/ext_auth/glovo').then(({data}) => {
                if (data.status === "operation_success") {
                    this.auth_ext = data.data;

                    if(this.general_fields.ext_id <= 0 && this.has_default) {
                        this.general_fields.ext_id = this.default_auth?.id || 0;
                    }

                    this.get_locations();
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },


        searchRest(options, search) {
            const fuse = new Fuse(options, {
                keys: [ 'id','address'],
                shouldSort: true,
            })
            return search.length ? fuse.search(search).map(({ item }) => item) : fuse.list
        },


        async get_locations() {
            this.ext_restaurants = [];
            this.is_load = true;

            if(this.general_fields.ext_id <= 0) {
                this.is_load = false;
                return;
            }

            let url =  '/aggregators/glovo/' + this.general_fields.ext_id +'/ext_restaurants';

            await agr_api.get(url).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.ext_restaurants = data.data;
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

    },

    computed : {

        has_default() {
            if(this.auth_ext.length > 0) {
                return this.auth_ext.some(item => item.is_default === true);
            }

            return false;
        },

        default_auth() {
            return this.auth_ext.find(item => item.is_default) || null;
        },

        general_fields() {
            if (this.location.hasOwnProperty("general_fields")) {
                return this.location.general_fields;
            }

            return {
                "id" : 0,
                "ext_id"   : 0,
                "store_id" : null,
            }
        }
    }
}
</script>



<style scoped>

</style>
